// @flow

import { all, put, takeEvery, select } from 'redux-saga/effects';
import { normalize } from 'normalizr';
import * as types from '../actionTypes';
import { HitchpinApi } from '../../api/Hitchpin';
import { getWantedActions, getWantedListActions } from '../actions/wanteds';
import * as schemata from '../schemata';
import genericFetcherSagas from './generic';
import { selectWanted } from '../reducers/wanteds';
import { selectSession } from '../reducers/session';

const customWantedSagas = {
  *handleWantedSearchResults(action) {
    const { results } = action;
    const sessionId = yield select(selectSession.sessionId);
    const wanteds = results.filter(wanted => !wanted.resourcetype);
    const { result, entities } = normalize(wanteds, [schemata.wanted]);

    yield put(getWantedListActions.success(result, entities, sessionId));
  },
};

export default function* (): Generator<any, void, any> {
  yield all([
    genericFetcherSagas(
      selectWanted,
      getWantedListActions,
      getWantedActions,
      types.GET_WANTED_ASYNC.MANY,
      types.GET_WANTED_ASYNC.SINGLE,
      HitchpinApi.wanteds,
      schemata.wanted,
    ),
    takeEvery(
      types.PREPOPULATE_WANTEDS,
      customWantedSagas.handleWantedSearchResults,
    ),
  ]);
}
